/* eslint-disable react/no-array-index-key */
import { Container } from 'react-bootstrap';
import { AnchorLink } from '../../../Components/button';
import { SimpleCard } from '../../../Components/Card';
import { SectionInnerHeading } from '../../../Components/Headings';
import { RightArrowWithBorder } from '../../../Components/icons';
import { SectionHeading } from '../../../Components/SectionHeading';
import image1 from '../../../assets/images/png/dermatologist.png';
import image2 from '../../../assets/images/png/gastroenterologist.png';
import image3 from '../../../assets/images/png/urologist.png';
import image4 from '../../../assets/images/png/child-specialist.png';
import image5 from '../../../assets/images/png/general-physician.png';
import './mostSearchedSpeciality.css';

const mostSearchedSpecialities = [
  {
    img: image1,
    title: 'Dermatologist'
  },
  {
    img: image2,
    title: 'Gastroenterologist'
  },
  {
    img: image3,
    title: 'Urologist'
  },
  {
    img: image4,
    title: 'Child Specialist'
  },
  {
    img: image5,
    title: 'General Physician'
  }
];

function MostSearchedSpeciality() {
  return (
    <section className="mostSearchedSpeciality">
      <Container>
        <SectionHeading
          heading="Most Searched Specialities"
          icon={<RightArrowWithBorder />}
          link={
            <AnchorLink to="/findADoctorViewAllSpecailist" text="BROWSE ALL" />
          }
        />
        <div className="mostSearchedSpecialityRow">
          {mostSearchedSpecialities.map((mostSearchedSpeciality, index) => {
            const { img, title } = mostSearchedSpeciality;
            return (
              <div className="mostSearchedSpecialityBox" key={index}>
                <SimpleCard>
                  <div className="imgBox">
                    <img src={img} alt="docImg" />
                  </div>
                  <div className="cardBody">
                    <SectionInnerHeading text={title} />
                  </div>
                </SimpleCard>
              </div>
            );
          })}
        </div>
      </Container>
    </section>
  );
}

export default MostSearchedSpeciality;
